import { combineReducers, createStore, Store } from "lib/store/v3";
import { ProductActions as Product } from "./Product/index";
import { createStoreLogger } from "lib/store/v3/createStoreLogger";

const reducer = combineReducers({ Product }, createStoreLogger("Product"));

export type ProductStore = Store<typeof reducer>;

export const { useSelector: useProductSelector, ...ProductStore } = createStore(reducer);
